import { useEffect, useState } from "react";

import { useHistory } from "@shared/context";

const useRestoreScrollOnBack = () => {
  const [scrollsTopToRestore, setScrollsTopToRestore] = useState<number[]>([]);
  const history = useHistory();

  useEffect(() => {
    // https://github.com/ReactTraining/history/blob/v4/docs/GettingStarted.md#listening
    // We need to use history.listen because when going forward (push, replace actions) in history
    // this gets called before the route actually changes.
    // That way we can access the scroll in the page before it changes
    // Any child component that wishes to manipulate the scroll in their own way can just use useEffect watching location changes
    // and their code will execute after this one, effectively overwriting this behaviour
    return history.listen(({ action }) => {
      if (action !== "POP") {
        // Going forward in history (push/replace)
        setScrollsTopToRestore([...scrollsTopToRestore, window.pageYOffset]);
        window.scrollTo(0, 0); // this is the common behaviour pretty much always, scroll needs to go back to top when navigating forward
      } else if (scrollsTopToRestore.length > 0) {
        // history.back called and we have previous scroll to restore
        const lastScrollToRestoreIndex = scrollsTopToRestore.length - 1;
        // requestAnimationFrame is used to ensure in certain parts of the app where there is a ton
        // of additional loading/rendering, the scroll position would still be restored.
        requestAnimationFrame?.(() =>
          window.scrollTo(0, scrollsTopToRestore[lastScrollToRestoreIndex])
        );
        setScrollsTopToRestore(scrollsTopToRestore.slice(0, lastScrollToRestoreIndex));
      }
    });
  }, [history, scrollsTopToRestore]);
};

export { useRestoreScrollOnBack };
